export default "__VITE_ASSET__B4TGA81Y__"